// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2jBTU","col":"CardReaderDesc_col__2RKOw","label":"CardReaderDesc_label__1XADV"};